import CapitalGainAmountError from './CapitalGainAmountError';
class CapitalGainCrowdfundingPropertyNotFound extends CapitalGainAmountError {
    propertyId;
    constructor(propertyId, options) {
        super('CROWDFUNDING_PROPERTY_NOT_FOUND', options);
        this.propertyId = propertyId;
    }
}
export default CapitalGainCrowdfundingPropertyNotFound;
